export function isDefrentChatUserData (oldData, newData) {
    if(oldData.length!==newData.length) return true;
    const olduser_account_id = (oldData || []).map(i=> i.user_account_id)
    const newuser_account_id = (newData || []).map(i=>i.user_account_id)
    const olduser_family = (oldData || []).map(i=> i.user_family)
    const newuser_family = (newData || []).map(i=>i.user_family)
    const olduser_image_type = (oldData || []).map(i=> i.user_image_type)
    const newuser_image_type = (newData || []).map(i=>i.user_image_type)
    const olduser_image_url = (oldData || []).map(i=> i.user_image_url)
    const newuser_image_url = (newData || []).map(i=>i.user_image_url)
    const olduser_name = (oldData || []).map(i=> i.user_name)
    const newuser_name = (newData || []).map(i=>i.user_name)
    const olduser_phone = (oldData || []).map(i=> i.user_phone)
    const newuser_phone = (newData || []).map(i=>i.user_phone)
    // console.log(JSON.stringify(olduser_account_id)!==JSON.stringify(newuser_account_id) ||
    // JSON.stringify(olduser_family)!==JSON.stringify(newuser_family) ||
    // JSON.stringify(olduser_image_type)!==JSON.stringify(newuser_image_type) ||
    // JSON.stringify(olduser_image_url)!==JSON.stringify(newuser_image_url) ||
    // JSON.stringify(olduser_name)!==JSON.stringify(newuser_name) ||
    // JSON.stringify(olduser_phone)!==JSON.stringify(newuser_phone));
    return JSON.stringify(olduser_account_id)!==JSON.stringify(newuser_account_id) ||
    JSON.stringify(olduser_family)!==JSON.stringify(newuser_family) ||
    JSON.stringify(olduser_image_type)!==JSON.stringify(newuser_image_type) ||
    JSON.stringify(olduser_image_url)!==JSON.stringify(newuser_image_url) ||
    JSON.stringify(olduser_name)!==JSON.stringify(newuser_name) ||
    JSON.stringify(olduser_phone)!==JSON.stringify(newuser_phone);
}
